"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSON_RPC_ERROR_CODES = exports.ProviderRpcError = void 0;
var ProviderRpcError = /** @class */ (function (_super) {
    __extends(ProviderRpcError, _super);
    function ProviderRpcError(message, code, data) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.data = data;
        _this.name = "ProviderRpcError";
        return _this;
    }
    return ProviderRpcError;
}(Error));
exports.ProviderRpcError = ProviderRpcError;
exports.JSON_RPC_ERROR_CODES = {
    PARSE_ERROR: -32700,
    INVALID_REQUEST: -32600,
    METHOD_NOT_FOUND: -32601,
    INVALID_PARAMS: -32602,
    INTERNAL_ERROR: -32603,
    INVALID_INPUT: -32000,
    RESOURCE_NOT_FOUND: -32001,
    RESOURCE_UNAVAILABLE: -32002,
    TRANSACTION_REJECTED: -32003,
    METHOD_NOT_SUPPORTED: -32004,
    LIMIT_EXCEEDED: -32005,
    JSON_RPC_VERSION_NOT_SUPPORTED: -32006,
    USER_REJECTED_REQUEST: 4001,
    UNAUTHORIZED: 4100,
    UNSUPPORTED_METHOD: 4200,
    DISCONNECTED: 4900,
    CHAIN_DISCONNECTED: 4901,
};
